import { render, staticRenderFns } from "./Typing.vue?vue&type=template&id=70fcf200"
import script from "./Typing.vue?vue&type=script&lang=js"
export * from "./Typing.vue?vue&type=script&lang=js"
import style0 from "./Typing.vue?vue&type=style&index=0&id=70fcf200&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports